import React from "react";
import styles from "./ToggleSlider.module.css";

function ToggleSlider({ checked, onChange }) {
  return (
    <label className={styles.switch}>
      <input
        type="checkbox"
        checked={checked}
        onChange={onChange}
      />
      <span className={styles.slider}></span>
    </label>
  );
}

export default ToggleSlider;
